import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../hooks';
import { Link } from 'react-router-dom';
// import {} from '../../../shared/TranscriptHistorySearch';
import { Loader, Dimmer } from 'semantic-ui-react';
import {
  TopBarContainer,
  SideNavContainer,
  SelectAuctionContainer,
  BreadcrumbContainer,
} from '../../../components/Dashboard';

import {
  Layout,
  PageNavContainer,
  MainContainer,
  PageNavLeftContainer,
  PageNavRightContainer,
} from './Styles';

import AuctionTranscriptReportHome from '../../../components/Dashboard/AuctionTranscriptReport/AuctionTranscriptReportHome';
import { dashboardBreadcrumb } from '../../../data/routes';


/*

TODO: Add ability to load a transcript for an auction (dashboard will have link to its transcript report)

*/

const AdminLayout = ({ auctionName, AuctionID, laneName, laneID, }) => {
  // console.log('Transcript Admin Layout', { auctionName, AuctionID, laneName });
  const {
    AuthStore: { memberName },
  } = useStores();
  const [auction, setAuction] = useState(auctionName);
  const [lane, setLane] = useState(laneName);

  const items = [
    dashboardBreadcrumb,
    { to: '/auctions', label: 'Auctions' },
    {
      // to: '/auctionTranscriptReport',
      label: 'Transcript Report',
    },
  ];

  const handleAuctionLaneChange = (auction, lane) => {
    //console.log('handleAuctionLaneChange', {auction, lane})
    if (auction) setAuction(auction);
    //if (lane) setLane(lane);
    setLane(lane);
  }

  const getAuctionAndLaneName = () => {
    // if (!auction || auction?.indexOf('[auctionName]') > -1) return 'Loading...'
    // if (!lane) return auction;
    // return `${auction} - ${lane}`;
    return auction;
  }
  const auctionAndLaneName = getAuctionAndLaneName();
  
  React.useEffect(() => {
    
  }, [])

  return (
    <Layout>
      <TopBarContainer
        auctionAndLaneName={''}
        // title={`Auction Transcript Report`}
        // laneName={`auctionLaneName`}
        memberName={memberName}
        showLogout
      />
      <SideNavContainer />
      <PageNavContainer>
        <PageNavLeftContainer>
          <BreadcrumbContainer>
            {items.map(({ to, label }) =>
              to ? (
                <Link key={to} to={to}>
                  {label}
                </Link>
              ) : (
                label
              ),
            )}
          </BreadcrumbContainer>
        </PageNavLeftContainer>
      </PageNavContainer>
      <MainContainer>
        <AuctionTranscriptReportHome
          AuctionID={AuctionID}
          laneID={laneID}
          auctionName={auction}
        //   laneName={laneName}
          onAuctionLaneChange={handleAuctionLaneChange}
        />
      </MainContainer>
    </Layout>
  );
};

export default observer(AdminLayout);
